import { useEffect } from 'react';

/**
 * Schreibt JSON-LD strukturierte Daten direkt in den <head>,
 * damit Suchmaschinen die LocalBusiness-Informationen sauber erfassen.
 */
const StructuredData = () => {
  useEffect(() => {
    const data = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      '@id': 'https://ss-craftedwithlove.de/#business',
      name: 'SS-craftedwithlove',
      alternateName: 'ss-craftedwithlove',
      description:
        'Individuelle Holzlasergravuren und personalisierte Geschenke aus der Werkstatt in Daiting.',
      image: 'https://ss-craftedwithlove.de/logo512.png',
      url: 'https://ss-craftedwithlove.de',
      telephone: '+49 151 68580886',
      email: 'ss.craftedwithlove@t-online.de',
      founder: { '@type': 'Person', name: 'Stephan Schuchardt' },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Am Brunnenfeld 20',
        postalCode: '86653',
        addressLocality: 'Daiting',
        addressRegion: 'Bayern',
        addressCountry: 'DE',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 48.8134,
        longitude: 10.8969,
      },
      areaServed: { '@type': 'Country', name: 'Deutschland' },
      sameAs: ['https://www.instagram.com/ss.craftedwithlove/'],
      priceRange: 'auf Anfrage',
      knowsAbout: [
        'Holzlasergravur',
        'Personalisierte Geschenke',
        'Hochzeitsgeschenke',
        'Holzschilder',
        'Schneidebretter',
      ],
    };

    let script = document.getElementById('ld-json-business');
    if (!script) {
      script = document.createElement('script');
      script.id = 'ld-json-business';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
  }, []);

  return null;
};

export default StructuredData;
